import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface AgentFormFieldProps {
  agents?: { label: string; value: string }[]
  loading?: boolean
}

export const AgentFormField: React.FC<AgentFormFieldProps> = ({ agents, loading }) => {
  const { control, setValue } = useFormContext<{ agent: string }>()

  return (
    <FormField
      name="agent"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Agent / PB</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={loading}
              placeholder={'Select an agent'}
              value={field.value}
              options={agents}
              setValue={(val) => setValue('agent', val, { shouldValidate: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
